
/**
 * Utility functions for managing onboarding state in local storage
 */

import { GLOBAL_ONBOARDING_FLAG, getChecklistStateKey } from './constants';

/**
 * Get onboarding completion status from local storage
 */
export const getLocalOnboardingStatus = (userId?: string): boolean => {
  // Check global flag first (fastest)
  if (localStorage.getItem(GLOBAL_ONBOARDING_FLAG) === 'true') {
    return true;
  }

  // If we have a user ID, check user-specific flag
  if (userId) {
    const userFlagKey = `onboarding-completed-${userId}`;
    if (localStorage.getItem(userFlagKey) === 'true') {
      return true;
    }
  }

  return false;
};

/**
 * Set onboarding completion status in local storage
 */
export const setLocalOnboardingStatus = (userId?: string, completed: boolean = true): void => {
  if (completed) {
    localStorage.setItem(GLOBAL_ONBOARDING_FLAG, 'true');
    
    if (userId) {
      localStorage.setItem(`onboarding-completed-${userId}`, 'true');
    }
  } else {
    localStorage.removeItem(GLOBAL_ONBOARDING_FLAG);
    
    if (userId) {
      localStorage.removeItem(`onboarding-completed-${userId}`);
    }
  }
};
